import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * CATIA-sınıfı Hole (Delik) Definition penceresi (FikoDialogCore içeriği).
 * Extension (limit/çap/derinlik) · Taban (Flat/V-dip) · Tür (Simple/Counterbored/Countersunk/Counterdrilled) · Diş (M).
 * Yüze tıklanan noktadan içeri matkap — canlı önizleme.
 */
@Component({
  selector: 'fikoyt-hole-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="sd" *ngIf="el && yon">
    <!-- ÇAP -->
    <div class="sd-grup">
      <div class="sd-bas">Çap & Diş</div>
      <div class="sd-row"><label>Çap (Ø)</label><div class="sd-num"><input type="number" min="0.1" step="0.5" [disabled]="!!el.holeThread" [ngModel]="el.holeCap ?? 10" (ngModelChange)="setNum('holeCap',$event)"/><span>mm</span></div></div>
      <label class="sd-chk"><input type="checkbox" [ngModel]="!!el.holeThread" (ngModelChange)="disAcKapa($event)"/> 🔩 Dişli (Threaded)</label>
      @if(el.holeThread){
        <div class="sd-row"><label>Standart</label>
          <select [ngModel]="el.holeThreadAd || 'M6'" (ngModelChange)="setDis($event)">
            @for(m of metrikler; track m.ad){ <option [value]="m.ad">{{m.ad}} (Ø{{m.cap}})</option> }
          </select>
        </div>
      }
    </div>

    <!-- EXTENSION (LİMİT) -->
    <div class="sd-grup">
      <div class="sd-bas">Derinlik (Extension)</div>
      <div class="sd-row"><label>Tür</label>
        <select [ngModel]="el.holeLimit || 'boyut'" (ngModelChange)="set('holeLimit',$event)">
          <option value="boyut">Kör (Blind)</option>
          <option value="tumu">Boydan Boya (Through All)</option>
          <option value="sonraki">Sonrakine Kadar</option>
          <option value="son">Sona Kadar</option>
          <option value="duzleme">Düzleme Kadar</option>
        </select>
      </div>
      @if((el.holeLimit || 'boyut') === 'boyut'){
        <div class="sd-row"><label>Derinlik</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.holeDerinlik ?? 20" (ngModelChange)="setNum('holeDerinlik',$event)"/><span>mm</span></div></div>
      }
      @if(el.holeLimit === 'duzleme'){
        <button class="sd-btn" (click)="hedefSec()">🎯 Hedef Düzlemi 3D'den Seç</button>
      }
    </div>

    <!-- TABAN (BOTTOM) -->
    @if((el.holeLimit || 'boyut') === 'boyut'){
      <div class="sd-grup">
        <div class="sd-bas">Taban (Bottom)</div>
        <div class="sd-seg">
          <button [class.aktif]="(el.holeAlt||'flat')==='flat'" (click)="set('holeAlt','flat')">▭ Düz</button>
          <button [class.aktif]="el.holeAlt==='vdip'" (click)="set('holeAlt','vdip')">▽ V-Dip</button>
        </div>
        @if(el.holeAlt === 'vdip'){
          <div class="sd-row"><label>Uç Açısı</label><div class="sd-num"><input type="number" min="30" max="180" step="2" [ngModel]="el.holeAltAci ?? 118" (ngModelChange)="setNum('holeAltAci',$event)"/><span>°</span></div></div>
        }
      </div>
    }

    <!-- TYPE -->
    <div class="sd-grup">
      <div class="sd-bas">Tür (Type)</div>
      <div class="sd-row"><label>Delik Türü</label>
        <select [ngModel]="el.holeTur || 'simple'" (ngModelChange)="set('holeTur',$event)">
          <option value="simple">Basit (Simple)</option>
          <option value="counterbored">Şişe Başı (Counterbored)</option>
          <option value="countersunk">Havşa Başı (Countersunk)</option>
          <option value="counterdrilled">Kademeli (Counterdrilled)</option>
        </select>
      </div>
      @if(el.holeTur === 'counterbored' || el.holeTur === 'counterdrilled'){
        <div class="sd-row"><label>Havşa Çapı</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.cbCap ?? 18" (ngModelChange)="setNum('cbCap',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Havşa Derinliği</label><div class="sd-num"><input type="number" min="0.1" step="0.5" [ngModel]="el.cbDerinlik ?? 6" (ngModelChange)="setNum('cbDerinlik',$event)"/><span>mm</span></div></div>
      }
      @if(el.holeTur === 'countersunk'){
        <div class="sd-row"><label>Havşa Çapı</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.csCap ?? 20" (ngModelChange)="setNum('csCap',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Havşa Açısı</label><div class="sd-num"><input type="number" min="30" max="180" step="2" [ngModel]="el.csAci ?? 90" (ngModelChange)="setNum('csAci',$event)"/><span>°</span></div></div>
      }
    </div>

    <!-- YÖN -->
    <div class="sd-grup">
      <button class="sd-btn" [class.aktif]="el.tersYon" (click)="set('tersYon',!el.tersYon)">⇅ Yön Çevir (diğer tarafa del)</button>
    </div>

    <div class="sd-altbar">
      <button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button>
      <button class="sd-btn sd-sil" (click)="sil()">🗑 Sil</button>
    </div>
  </div>
  `,
  styles: [`
    .sd{padding:6px 10px 10px;color:#dbe4f0;font:500 12px/1.4 system-ui,sans-serif;min-width:240px;}
    .sd-grup{border-top:1px solid rgba(120,160,255,.16);padding:6px 0 3px;}
    .sd-grup:first-child{border-top:none;}
    .sd-bas{font-size:10px;font-weight:800;color:#7db0ff;text-transform:uppercase;letter-spacing:.5px;margin:0 0 5px;}
    .sd-row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:3px 0;}
    .sd-row label{font-size:11.5px;color:#aab8cc;}
    .sd-row select{flex:1;max-width:160px;background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;font-size:11px;cursor:pointer;outline:none;}
    .sd-num{display:flex;align-items:center;gap:4px;}
    .sd-num input{width:64px;background:rgba(0,0,0,.4);color:#fff;font-weight:700;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;outline:none;}
    .sd-num input:focus{border-bottom-color:#00d0ff;background:rgba(0,60,80,.5);}
    .sd-num input:disabled{opacity:.5;}
    .sd-num span{color:#00d0ff;font-size:10px;}
    .sd-chk{display:flex;align-items:center;gap:7px;font-size:11.5px;color:#cbd5e1;cursor:pointer;padding:3px 0;}
    .sd-chk input{accent-color:#00d0ff;cursor:pointer;width:14px;height:14px;}
    .sd-seg{display:flex;gap:5px;}
    .sd-seg button{flex:1;background:rgba(20,40,60,.7);color:#cfe6f5;border:1px solid rgba(0,200,255,.25);border-radius:6px;padding:5px;font-size:11.5px;cursor:pointer;transition:all .15s;}
    .sd-seg button.aktif{background:rgba(0,200,255,.3);border-color:#00d0ff;color:#fff;}
    .sd-btn{width:100%;margin-top:4px;background:rgba(20,40,60,.7);color:#cfe6f5;border:1px solid rgba(0,200,255,.3);border-radius:6px;padding:5px;font-size:11.5px;font-weight:600;cursor:pointer;transition:all .15s;}
    .sd-btn:hover{background:rgba(0,150,200,.4);border-color:#00d0ff;}
    .sd-btn.aktif{background:rgba(0,200,255,.3);border-color:#00d0ff;color:#fff;}
    .sd-altbar{display:flex;gap:6px;margin-top:8px;}
    .sd-altbar .sd-btn{margin-top:0;}
    .sd-ok{background:rgba(20,120,80,.55);border-color:rgba(52,211,153,.5);color:#a7f3d0;}
    .sd-ok:hover{background:rgba(20,160,100,.7);}
    .sd-sil{flex:0 0 70px;background:rgba(120,30,30,.5);border-color:rgba(239,68,68,.5);color:#fca5a5;}
    .sd-sil:hover{background:rgba(160,40,40,.7);}
  `]
})
export class FikoHoleDialog {
  @Input() element: any;   // IOzellik (hole)
  @Input() yonetici: any;  // FikoModellemeYonetici
  @Input() pencere: any;   // FikoDialogCore
  get el() { return this.element; }
  get yon() { return this.yonetici; }

  /** Metrik kaba diş → tap-drill (delik) çapı (ISO 261). */
  metrikler = [
    { ad: 'M3', cap: 2.5 }, { ad: 'M4', cap: 3.3 }, { ad: 'M5', cap: 4.2 }, { ad: 'M6', cap: 5.0 },
    { ad: 'M8', cap: 6.8 }, { ad: 'M10', cap: 8.5 }, { ad: 'M12', cap: 10.2 }, { ad: 'M14', cap: 12.0 },
    { ad: 'M16', cap: 14.0 }, { ad: 'M20', cap: 17.5 }, { ad: 'M24', cap: 21.0 },
  ];

  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  set(anahtar: string, deger: any): void { this.yonetici?.padGuncelle(this.element, anahtar, deger); this.CD.markForCheck(); }
  setNum(anahtar: string, deger: any): void { const v = +deger; if (!isNaN(v)) this.yonetici?.padGuncelle(this.element, anahtar, v); this.CD.markForCheck(); }

  /** Diş aç/kapat: açılırken varsayılan M6 standardına ayarla. */
  disAcKapa(acik: boolean): void {
    this.element.holeThread = !!acik;
    if (acik) this.setDis(this.element.holeThreadAd || 'M6'); else { this.yonetici?.padGuncelle(this.element, 'holeThread', false); }
    this.CD.markForCheck();
  }
  /** Metrik diş seç → etiket + tap-drill çapı. */
  setDis(ad: string): void {
    const m = this.metrikler.find(x => x.ad === ad) || this.metrikler[3];
    this.element.holeThreadAd = m.ad; this.element.holeThread = true;
    this.yonetici?.padGuncelle(this.element, 'holeCap', m.cap);
    this.CD.markForCheck();
  }
  /** Up-to-plane: 3D'den hedef düzlem seç (yönetici limitHedefSec ile). */
  hedefSec(): void { this.yonetici?.limitHedefSecBaslat?.(this.element); }

  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
